import React from 'react';
export const ExtendedTestimonialsSection = ({
  isInitial = false
}: {
  isInitial?: boolean;
}) => {
  const initialTestimonials = [{
    initials: 'MR',
    name: 'Marta R.',
    city: 'Buenos Aires',
    desc: 'Hija y cuidadora familiar · Buenos Aires',
    quote: 'Mi mamá tiene 78 años y empezaba con olvidos frecuentes. No sabía cómo ayudarla sin que se sintiera incómoda o tratada como una nena. Con el Cuaderno Mente Despierta ahora compartimos actividades todas las tardes. Me dio una forma clara y amorosa de acompañarla.'
  }, {
    initials: 'RG',
    name: 'Ricardo G.',
    city: 'Córdoba',
    desc: 'Cuidador profesional a domicilio · Córdoba',
    quote: 'Soy cuidador a domicilio y el Módulo VIP de +150 ejercicios me ayudó muchísimo. Tengo actividades físicas y cognitivas organizadas por niveles para cada persona. Las familias valoran tener un plan más claro y yo dejé de improvisar.'
  }];
  const extendedTestimonials = [...initialTestimonials, {
    initials: 'LF',
    name: 'Laura F.',
    city: 'La Plata',
    desc: 'Hija y cuidadora · La Plata',
    quote: 'La Bitácora de Control 360 ordenó todo lo que antes eran papelitos sueltos. Ahora llevo mejor registro de presión, glucemia y medicación para la consulta médica de mi papá. Me dio mucha tranquilidad.'
  }, {
    initials: 'JR',
    name: 'Javier R.',
    city: 'Tucumán',
    desc: 'Nieto y cuidador familiar · Tucumán',
    quote: 'Nunca imaginé que iba a poder compartir ejercicios con mi abuelo. La Guía Movilidad Sin Miedo tiene todo explicado con dibujos. Hacemos algunas rutinas en silla y se volvió un momento lindo para compartir.'
  }, {
    initials: 'CM',
    name: 'Carolina M.',
    city: 'Santa Fe',
    desc: 'Cuidadora principal · Santa Fe',
    quote: 'La Guía del Cuidador me ayudó a darme cuenta de que estaba haciendo todo sola. El mapa familiar del cuidado me sirvió para hablar con mis hermanos y empezar a repartir responsabilidades.'
  }];
  const data = isInitial ? initialTestimonials : extendedTestimonials;
  return <section className={`py-10 md:py-16 px-4 md:px-6 ${isInitial ? 'bg-familia-bg' : 'bg-familia-card'}`} data-id="element-49">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-50">
        {!isInitial && <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-51">
            Lo que dicen las familias y cuidadores que ya{' '}
            <br className="hidden sm:block" data-id="element-52" /> usan el Vitalidad 360:
          </h2>}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-53">
          {data.map((t, i) => <div key={i} className="bg-familia-section border border-familia-cyan/25 p-5 md:p-8 rounded-2xl card-hover flex flex-col" data-id="element-54">
              <div className="flex items-center gap-4 mb-4 md:mb-6" data-id="element-55">
                <div className="w-12 h-12 rounded-full bg-familia-cyan text-familia-bg flex items-center justify-center font-bold text-lg shrink-0" data-id="element-56">
                  {t.initials}
                </div>
                <div data-id="element-57">
                  <div className="text-familia-gold text-sm mb-1" data-id="element-58">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <div className="font-bold text-sm" data-id="element-59">{t.name}</div>
                  <div className="text-familia-gray text-[10px] uppercase tracking-wider" data-id="element-60">
                    {t.city}
                  </div>
                </div>
              </div>
              <p className="text-white/90 italic mb-4 md:mb-6 flex-grow leading-relaxed text-[15px]" data-id="element-61">
                "{t.quote}"
              </p>
              <div className="text-xs font-semibold text-familia-cyan/90 pt-4 border-t border-white/10" data-id="element-62">
                {t.desc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};